// screen: Help center — the Studio user manual (overview)
import { createFileRoute } from '@tanstack/react-router';
import { HelpCenter } from '~/help/HelpCenter';
import { OVERVIEW } from '~/help/content';

export const Route = createFileRoute('/_layout/t/$slug/help')({ component: Screen });

function Screen() {
  const { slug } = Route.useParams();
  return <HelpCenter slug={slug} topicId={OVERVIEW} />;
}
